<template>
	<div class="modify-stock">
		<el-dialog title="修改库存" top="4vh" width="800px" :close-on-click-modal="false" :close-on-press-escape="false"
			:visible.sync="dialogVisible" @close="closeDialog">
			<el-tabs v-model="tabName" @tab-click="handleTabClick">
				<template v-for="item in listTabs">
					<el-tab-pane :label="item.sku" :name="item.sku">
						<!-- 表单 -->
						<el-form class="custom-form" inline>
							<el-form-item label="库存">
								<el-input type="text" placeholder="请输入库存" v-model="formData.stock"></el-input>
							</el-form-item>
							<el-form-item label="预处理时间">
								<el-input type="text" placeholder="请输入预处理时间"
									v-model="formData.preprocessingTime"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="setTableVal">设 置</el-button>
							</el-form-item>
						</el-form>
						<!-- 表格 -->
						<el-table :data="processedData" border>
							<el-table-column prop="sku" label="SKU" align="center" width="300">
								<template slot-scope="scope">
									{{ scope.row.sku }}
								</template>
							</el-table-column>
							<el-table-column label="库存" align="center">
								<template slot-scope="scope">
									<el-input v-model="scope.row.newStockQuantity" type="number" min="0"
										placeholder="请输入库存"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="预处理时间 (天)" align="center">
								<template slot-scope="scope">
									<el-input v-model="scope.row.newLeadTime" type="number" min="0"
										placeholder="请输入处理时间"></el-input>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</template>
			</el-tabs>
			<div slot="footer">
				<el-button type="primary" @click="updateDataOne()" :loading="loadingUpdate"
					:disabled="listTabs.length != 1 ? true : false">更 新 当 前</el-button>
				<el-button type="primary" @click="updateAllData()" :loading="loadingUpdate"
					:disabled="listTabs.length == 1 ? true : false">更 新 所 有</el-button>
				<el-button type="primary" @click="addItems()" :disabled="listTabs.length == 1 ? true : false">保 存 到 队 列
					中</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
const variantMaps = new Map()

export default {
	name: 'ModifyStock',

	data() {
		return {
			dialogVisible: false,
			tabName: '',  // 控制当前激活的选项卡
			tabIndex: 0,  // 当前选项卡索引
			shopItem: null,
			listTabs: [],
			formData: {
				stock: '',
				preprocessingTime: '',
			},
			loadingUpdate: false,
			loadingUpload: false,
			paramsDataOne: null,
			paramsDataAll: []
		}
	},

	methods: {
		openDialog(list, shopItem) {
			this.shopItem = shopItem
			this.listTabs = JSON.parse(JSON.stringify(list))
			this.tabName = list[0].sku
			this.tabIndex = 0
			this.handleTabClick()
			this.refreshTableLoad()
			this.dialogVisible = true
			this.isUpdate = false
		},
		closeDialog() {
			if (this.isUpdate) {
				this.$emit('close')
			}
		},
		handleTabClick() {
			// 通过 tabName 更新 tabIndex
			this.tabIndex = this.listTabs.findIndex(item => item.sku === this.tabName);
			// 强制 Vue 重新渲染，确保 tabIndex 的变化触发视图更新
			this.$forceUpdate();
		},
		async tableLoad(tree, treeNode, resolve) {
			variantMaps.set(tree.id, { tree, treeNode, resolve })
			const variantData = await this.getTableItemVariant(tree)
			resolve(variantData)
		},
		refreshTableLoad() {
			try {
				this.listTabs.forEach((item) => {
					const itemObj = variantMaps.get(item.id)
					if (!itemObj) return
					const { tree, treeNode, resolve } = itemObj
					if (tree) {
						this.tableLoad(tree, treeNode, resolve)
					}
				})
			} catch (e) {
				console.log(e)
			}
		},
		getTableItemVariant(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						data.forEach((item) => {
							item.cusSku = item.childSku
							item.cusImgUrl = item.variantEanImageUrl
							const countryVal =
								item.productPriceObject[tree.areaName]
							item.cusPrice = `${countryVal.value} (${countryVal.currency})`
							item.cusSalePrice = `${item.sale || 0} (${countryVal.currency
								})`
							item.cusProductPrice = `${countryVal.value}`
							item.cusTitle = `${tree.title ||
								''} ${item.childSku || ''}`
							item.isShow = false
							item.saleTime = [
								item.saleBeginTime || '',
								item.saleEndTime || '',
							]
							item.cusStock = item.stock
							item.cusImages = item.imagesList
						})
						this.listTabs[this.tabIndex].children = data
						resolve(data)
					} else {
						reject('400')
					}
				})
			})
		},
		setTableVal() {
			const stock = parseInt(this.formData.stock, 10);
			const preprocessingTime = parseInt(this.formData.preprocessingTime, 10);
			if (isNaN(stock) && isNaN(preprocessingTime)) {
				this.$message.warning("请输入库存或处理时间！");
				return;
			}
			const currentTab = this.listTabs[this.tabIndex];
			if (!currentTab || !currentTab.amazonOnlineInfoList) {
				this.$message.error("无法更新数据：当前选项卡数据不存在！");
				return;
			}
			currentTab.amazonOnlineInfoList.forEach((item) => {
				if (!isNaN(stock)) {
					this.$set(item.fulfillment_availability, "quantity", stock);
				}
				if (!isNaN(preprocessingTime)) {
					this.$set(item.fulfillment_availability, "lead_time_to_ship_max_days", preprocessingTime);
				}
			});
			this.$message.success("数据已成功设置！");
		},
		submitUpdate() {
			const currentTab = this.listTabs[this.tabIndex];
			if (!currentTab || !currentTab.amazonOnlineInfoList) {
				this.$message.error("无法提交数据：当前选项卡数据不存在！");
				this.loadingUpdate = false;
				return;
			}
			// 构建提交数据
			const requestPayload = {
				listingId: currentTab.listingId,
				rid: JSON.parse(localStorage.getItem('role') || '{}').rid,
				amazonOnlineInfoList: currentTab.amazonOnlineInfoList.map((item) => {
					const newRow = this.processedData.find((row) => row.sku === item.sku);
					return {
						sku: item.sku,
						fulfillment_availability: {
							quantity: Number(newRow.newStockQuantity) || item.fulfillment_availability.quantity,
							lead_time_to_ship_max_days: Number(newRow.newLeadTime) || item.fulfillment_availability.lead_time_to_ship_max_days,
							fulfillment_channel_code: item.fulfillment_availability.fulfillment_channel_code || "DEFAULT",
						},
					};
				}),
			};
			if (this.listTabs.length == 1) {
				this.paramsDataOne = requestPayload
			} else {
				this.paramsDataAll.push(requestPayload)
			}
		},
		handleUpload() {
			const API = Baseurl + 'dataController/uploadDataFile';
			const formData = new FormData();
			formData.append('file', this.uploadFile);
			ajaxPost(API, formData).then((response) => {
				this.$message.success('数据上传成功');
			}).catch((error) => {
				this.$message.error('数据上传失败');
			});
		},
		updateDataOne() {
			this.loadingUpdate = true;
			this.submitUpdate();
			let API = Baseurl + 'amazonProductListing/batchModifyInventory'
			ajaxPost(API, [this.paramsDataOne])
				.then((res) => {
					if (res.data.code == 200) {
						this.$message.success("数据已成功提交！");
						this.loadingUpdate = false;
						this.dialogVisible = false;
						this.$parent.$refs.multipleTable.clearSelection();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		updateAllData() {
			this.loadingUpdate = true;
			this.paramsDataAll = this.filterDuplicateSku(this.paramsDataAll)
			let API = Baseurl + 'amazonProductListing/batchModifyOffer'
			ajaxPost(API, this.paramsDataAll)
				.then((res) => {
					if (res.data.code == 200) {
						this.$message.success("数据已成功提交！");
						this.loadingUpdate = false;
						this.dialogVisible = false;
						this.$parent.$refs.multipleTable.clearSelection();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		filterDuplicateSku(arr) {
			const seenListingIds = new Set();  // 记录已处理过的 listingId
			const result = [];
			arr.forEach(item => {
				// 检查 item 是否已经处理过，基于 listingId
				if (!seenListingIds.has(item.listingId)) {
					seenListingIds.add(item.listingId);  // 添加到 Set 中，避免重复
					result.push(item);  // 将该项加入结果
				}
			});
			return result;
		}
		,
		addItems() {
			this.submitUpdate()
			if ((this.tabIndex + 1) != this.listTabs.length) {
				this.tabIndex += 1;
				this.tabName = this.listTabs[this.tabIndex].sku
				this.handleTabClick()
			} else {
				this.$message.success("加入队列成功,已到最后一个选项卡,请注意更新所有!");
			}
		},
	},
	computed: {
		// 计算属性，处理选项卡数据
		processedData() {
			const currentTab = this.listTabs[this.tabIndex];
			if (!currentTab || !currentTab.amazonOnlineInfoList) {
				return [];
			}
			return currentTab.amazonOnlineInfoList.map(item => {
				const fulfillment = item.fulfillment_availability || {};
				return {
					...item,
					newStockQuantity: fulfillment.quantity,
					newLeadTime: fulfillment.lead_time_to_ship_max_days,
				};
			});
		},
	}
}
</script>
